var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSouthCarolina(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.564,62.101l-48.059,5.391c0,0-8.98-13.922-10.777-14.148c-1.8-0.225-66.022,4.717-66.022,4.717l-42.96,21.626 c-2.837,3.963-7.312,11.137-5.097,14.301c3.146,4.493,15.72,11.229,17.068,11.229c0.078,0,0.178,0,0.287,0c1.774,0,7.35,0,7.35,0 l17.963,28.744c0,0,20.211,13.475,25.6,19.761c5.388,6.288,9.881,13.024,22.455,20.659c12.576,7.637,18.415,19.313,24.252,35.033 c0,0,11.23,3.591,13.474,11.226c2.245,7.637,3.594,13.587,3.594,13.587h12.121l18.416-19.872v-7.638h6.291 c0,0,11.225-13.023,22.453-25.15c11.229-12.124,12.578-15.718,12.578-15.718h6.735l3.146-10.329c0,0,7.633-33.238,15.719-40.869 c3.962-3.745,6.625-5.971,8.311-7.273c1.762-1.354,2.469-1.711,2.469-1.711L197.564,62.101z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthCarolina);
export default __webpack_public_path__ + "static/media/southCarolina.d948b2d37e4b58d1d133b8c49019a96d.svg";
export { ForwardRef as ReactComponent };